import { render, staticRenderFns } from "./UserPasswd.vue?vue&type=template&id=3134de6a"
import script from "./UserPasswd.js?vue&type=script&lang=js&external"
export * from "./UserPasswd.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports